export default __webpack_public_path__ + "static/media/Polisport_Logo_Corporate.0f7b5ef2.svg";